"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../../utils/api");
var toolkit_1 = require("@reduxjs/toolkit");
var config_1 = __importStar(require("../../config"));
var validateAccountPin_1 = __importDefault(require("./queries/validateAccountPin"));
var resetAccountPin_1 = __importDefault(require("./queries/resetAccountPin"));
var selectors_1 = require("../customer/selectors");
var constants_1 = require("./constants");
exports.clearAccountPinValidationResult = function () { return function (dispatch, getState) {
    var userProfileId = selectors_1.selectedProfileId(getState());
    return dispatch(toolkit_1.createAction(constants_1.CLEAR_VALIDATE_ACCOUNT_PIN)({ userProfileId: userProfileId }));
}; };
// eslint-disable-next-line import/prefer-default-export
exports.validateAccountPin = function (pinType, enteredPin) { return function (dispatch, getState) {
    var userProfileId = selectors_1.selectedProfileId(getState());
    return dispatch(api_1.createApiAction(constants_1.VALIDATE_ACCOUNT_PIN, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: validateAccountPin_1.default,
            variables: { pinType: pinType, enteredPin: enteredPin },
        },
        authenticated: true,
        graphQL: true,
        meta: { lastEnteredPin: enteredPin, userProfileId: userProfileId },
    }));
}; };
exports.resetAccountPin = function (pinType) {
    return api_1.createApiAction(constants_1.RESET_ACCOUNT_PIN, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: resetAccountPin_1.default,
            variables: { pinType: pinType },
        },
        authenticated: true,
        graphQL: true,
    });
};
//# sourceMappingURL=actions.js.map